(function ($) {
	const $fieldWrap = $('[class*="js_pre_fill_"]');

	if (!$fieldWrap.length) {
		return;
	}

	$fieldWrap.each(function () {
		const $this = $(this);
		// the param is what follows the js_pre_fill_ class
		const get_param = $this.attr('class').split('js_pre_fill_')[1].split(' ')[0];

		// get the value of the GET param
		const urlParams = new URLSearchParams(window.location.search);
		const myParam = urlParams.get(get_param);

		// if the GET param is set
		if (myParam) {
			const $input = $this.find('input');
			$input.val(myParam);
		}
	});
})(jQuery);
